import React from 'react'
import { SidebarCard } from '@/components/SidebarCard'
import { RenderBlocks, type Block } from '@/blocks/RenderBlocks'

export type SidebarCardBlockProps = {
  title: string
  content?: Block[] | null
  className?: string
  blockType: 'sidebarCard'
}

export const SidebarCardBlock: React.FC<SidebarCardBlockProps> = ({ title, content, className }) => {
  return (
    <SidebarCard title={title} className={className}>
      <RenderBlocks blocks={content ?? []} />
    </SidebarCard>
  )
}
